import styled from '@emotion/styled'
import 'react-calendar-timeline/lib/Timeline.css'

export const TimelineContainer = styled.div`
  border: 1px solid #bbbbbb;
`

export const VerticalSpacer = styled.div`
  padding: 0px 20px;
`
export const CheckBoxContainer = styled.div`
  border-bottom: 3px solid
    ${(props) => (props.color ? props.color : TimeLineItemColors.default)};
  margin: 5px 30px 5px 0;
  padding: 0 0 5px 0;
`

export const TimeLineItemColors = {
  default: '#FFFFFF',
  participant: '#54575B',
  cars: '#C51F20',
  accomodation: '#fcf4d9',
  flight: '#C51F20',
  trackHotel: '#ed8312',
  ferry: '#252ced',
  rentalCar: '#8388ea',
  carTransportation: '#ed8312',
}

export const TimeLineItemStyles = {
  participant: {
    style: {
      color: TimeLineItemColors.participant,
      background: '#FFF',
      border: '1px solid #BBBBBB',
    },
  },
  cars: {
    style: {
      background: TimeLineItemColors.cars,
      border: '1px solid #BBBBBB',
    },
  },
  carTransportation: {
    style: {
      color: 'white',
      background: '#FDD20EFF',
      border: '1px solid yellow',
    },
  },
  resourceAvailabilityGreen: {
    style: {
      textAlign: 'center',
      color: 'white',
      background: '#A9CF54',
      border: '1px solid black',
    },
  },
  resourceAvailabilityYellow: {
    style: {
      textAlign: 'center',
      color: 'black',
      background: '#F7E967',
      border: '1px solid black',
    },
  },
  resourceAvailabilityRed: {
    style: {
      textAlign: 'center',
      color: 'white',
      background: '#F1433F',
      border: '1px solid black',
    },
  },
  accomodation: {
    style: {
      color: '1px solid #54575B',
      background: TimeLineItemColors.accomodation,
      border: '1px solid #BBBBBB',
    },
  },
  flight: {
    style: {
      background: TimeLineItemColors.flight,
      border: '1px solid #BBBBBB',
    },
  },
  trackHotel: {
    style: {
      background: TimeLineItemColors.trackHotel,
      border: '1px solid #BBBBBB',
    },
  },
  ferry: {
    style: {
      background: TimeLineItemColors.ferry,
      border: '1px solid #BBBBBB',
    },
  },
  rentalCar: {
    style: {
      background: TimeLineItemColors.rentalCar,
      border: '1px solid #BBBBBB',
    },
  },
}

export const TimeLineLeftBarGroupColors: { [id: string]: string } = {
  Building: '#5291DF',
  Office: '#B9D4F3',
  Persons: '#5291DF',
  testing: '#5291DF',
  MainCategory: '#5291DF',
  SubCategory: '#B9D4F3',
  TestTrack: '#B9D4F3',
  interimBadge: '#5291DF',
  radio: '#5291DF',
  accessCard: '#5291DF',
  remoteControl: '#5291DF',
  coldCell: '#5291DF',
  chargingInfrastructure: '#5291DF',
  fuelCard: '#5291DF',
  fuel: '#5291DF',
}

export const Status = [
  {
    id: '1',
    color: '#0101FF',
  },
  {
    id: '2',
    color: '#A4262C',
  },
  {
    id: '3',
    color: '#107c10',
  },
  {
    id: '4',
    color: '#008002',
  },
  {
    id: '5',
    color: '#FF8101',
  },
  {
    id: '6',
    color: '#A16251',
  },
  {
    id: '7',
    color: '#FF02FF',
  },
  {
    id: '8',
    color: '#CCCCCC',
  },
  // {
  //   id: '9',
  //   color: '#107c10',
  // },
  {
    id: '10',
    color: '#bad80a',
  },
]
